import axios from "axios";
import { API_BE4FE_URL } from "../config";
import { RootState } from "../reducers/store";
import { createHttpHeaderWithAuthorization } from "../services/http-header";

export const GET_COMPANIES_START = "GET_COMPANIES_START";
export const GET_COMPANIES_SUCCESS = "GET_COMPANIES_SUCCESS";
export const GET_COMPANIES_ERROR = "GET_COMPANIES_ERROR";
export const CLEAR_COMPANIES = "CLEAR_COMPANIES";

export const getCompanies = (genericField: string) => {
    return (dispatch: any, getState: () => RootState) => {
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;
            dispatch({ type: GET_COMPANIES_START });
            axios
                .get(
                    `${API_BE4FE_URL}/companies?itemId=${itemId}&generic_field=${genericField}`,
                    {
                        headers: dispatch(
                            createHttpHeaderWithAuthorization(true),
                        ),
                    },
                )
                .then((result) => {
                    dispatch({
                        type: GET_COMPANIES_SUCCESS,
                        payload: result.data,
                    });
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch({ type: GET_COMPANIES_ERROR });
                    reject(e);
                });
        });
    };
};

export const clearCompanies = () => {
    return (dispatch: any) => {
        dispatch({ type: CLEAR_COMPANIES });
    };
};
